import { useEffect, useState } from 'react';

import type { ErrorLike } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import { gql } from '@graphql/__generated__';
import { MutationErrorSnackbar } from '@modules/_shared/components/MutationErrorModal';
import { PropertySearchesCard } from '@modules/_shared/components/property-search/PropertySearchesCard';

const GET_USER_PROPERTY_SEARCHES = gql(/* GraphQL */ `
  query GetUserPropertySearches($userId: uuid!) {
    property_searches(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
      limit: 100
    ) {
      ...PropertySearchesCardPropertySearches
    }
  }
`);

type UserPropertySearchCardProps = {
  userId: string;
  readOnly?: boolean;
};

export const UserPropertySearchCard = ({
  userId,
  readOnly = false,
}: UserPropertySearchCardProps) => {
  const [apolloError, setErrorLike] = useState<ErrorLike | null>(null);

  const { data, refetch, error } = useQuery(GET_USER_PROPERTY_SEARCHES, {
    variables: { userId },
  });

  useEffect(() => {
    if (error) {
      setErrorLike(error);
    }
  }, [error]);

  return (
    <>
      <PropertySearchesCard
        propertySearches={data?.property_searches ?? []}
        prefilledUserId={userId}
        defaultExpanded
        readOnly={readOnly}
        onCreate={readOnly ? undefined : () => refetch()}
        onUpdate={readOnly ? undefined : () => refetch()}
        onDelete={readOnly ? undefined : () => refetch()}
      />

      <MutationErrorSnackbar
        error={apolloError}
        onClose={() => setErrorLike(null)}
      />
    </>
  );
};
